import { useState, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export const useTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTasks = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get('/tasks/');
      setTasks(response.data);
    } catch (error) {
      toast.error('Failed to fetch tasks');
      console.error('Error fetching tasks:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const createTask = async (taskData) => {
    try {
      const response = await axios.post('/tasks/', taskData);
      setTasks(prev => [response.data, ...prev]);
      toast.success('Task created successfully!');
      return true;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to create task';
      toast.error(message);
      return false;
    }
  };

  const updateTask = async (taskId, taskData) => {
    try {
      const response = await axios.put(`/tasks/${taskId}`, taskData);
      setTasks(prev => 
        prev.map(task => 
          task.id === taskId ? response.data : task
        )
      );
      toast.success('Task updated successfully!');
      return true;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to update task';
      toast.error(message);
      return false;
    }
  };

  const deleteTask = async (taskId) => {
    try {
      await axios.delete(`/tasks/${taskId}`);
      setTasks(prev => prev.filter(task => task.id !== taskId));
      toast.success('Task deleted successfully!');
      return true;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to delete task';
      toast.error(message);
      return false;
    }
  };

  const toggleTaskComplete = async (taskId, completed) => {
    return updateTask(taskId, { completed });
  };

  return {
    tasks,
    loading,
    fetchTasks,
    createTask,
    updateTask,
    deleteTask,
    toggleTaskComplete,
  };
};
